export const hasDigit = (string: string) => {
  return RegExp(/(?=.*\d)/).test(string);
}
